import { useEffect, useState } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import CustomTitle from '../../../components/CustomMiscellaneous/CustomTitle';
import useMemoryState from '../../../hooks/memoryStateHook';
import Acabamentos from './Acabamentos/Acabamentos';
import CNC from './CNC/CNC';
import ControloEQualidade from './ControloEQualidade/ControloEQualidade';
import Convencionais from './Convencionais/Convencionais';
import Projeto from './Projeto/Projeto';
import Serrote from './Serrote/Serrote';
import Tratamento from './Tratamento/Tratamento';




export default function Operacoes() {

    const [tab, setTab] = useMemoryState('o-tab', 0)


    return (
        <div>
            <CustomTitle text={'Operações'} small />

            <div style={{ margin: 20 }} >
                {/* TODO add this back variant='soft-rounded' */}
                <Tabs  selectedIndex={tab} onSelect={(index) => setTab(index)}>
                    <TabList>
                        <Tab>Projeto</Tab>
                        <Tab>CNC</Tab>
                        <Tab>Convencionais</Tab>
                        <Tab>Serrote</Tab>
                        <Tab>Acabamentos</Tab>
                        <Tab>Tratamentos</Tab>
                        <Tab>Controlo e Qualidade</Tab>
                        {/* <Tab>Expedição</Tab> */}
                    </TabList>
                    <TabPanel>
                        <Projeto/>
                    </TabPanel>
                    <TabPanel>
                        <CNC/>
                    </TabPanel>
                    <TabPanel>
                        <Convencionais/>
                    </TabPanel>
                    <TabPanel>
                        <Serrote/>
                    </TabPanel>
                    <TabPanel>
                        <Acabamentos/>
                    </TabPanel>
                    <TabPanel>
                        <Tratamento/>
                    </TabPanel>
                    <TabPanel>
                        <ControloEQualidade/>
                    </TabPanel>
                 
                </Tabs>
            </div>
        </div>
    )


}